import { jsxs as y, Fragment as E, jsx as t } from "react/jsx-runtime";
import { FileSelectorModal as x } from "@systemeio/file-manager";
import { TextSelection as v } from "../../node_modules/prosemirror-state/dist/index.mjs";
import { useEditorState as F } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as S, useEffect as d } from "react";
import { twJoin as B } from "tailwind-merge";
import { LinkBubbleEdit as w, LinkBubbleView as O } from "./link-bubble-state.mjs";
import { BubbleMenu as T } from "../../components/bubble-menu/BubbleMenu.mjs";
const I = ({ editor: e, fileSource: o, options: i }) => {
  const r = F({
    editor: e,
    selector: ({ editor: n }) => ({
      href: n == null ? void 0 : n.getAttributes("link").href
    })
  }), a = r == null ? void 0 : r.href, [M, l] = S(!1), [f, c] = S(!1);
  d(() => {
    l(!a);
  }, [a]);
  const L = () => e == null ? void 0 : e.chain().focus().extendMarkRange("link").unsetLink().setMeta("addToHistory", !1).run(), m = (n) => {
    e && (l(!1), e.chain().focus().extendMarkRange("link").setLink({ href: n }).run());
  }, u = () => {
    if (!e) return;
    const n = e.state.schema.marks.link;
    if (!n) return;
    const { tr: s } = e.state;
    let h = !1;
    e.state.doc.descendants((p, k) => {
      p.marks.some((b) => b.type === n && !b.attrs.href) && (s.removeMark(k, k + p.nodeSize, n), h = !0);
    }), h && (s.setMeta("addToHistory", !1), e.view.dispatch(s));
  }, g = () => {
    l(!1), u();
  };
  return !e || !(e != null && e.options.editable) ? null : /* @__PURE__ */ y(E, { children: [
    /* @__PURE__ */ t(
      T,
      {
        className: B(f && "hidden"),
        editor: e,
        pluginKey: "linkBubbleMenu",
        options: {
          onHide: g
        },
        shouldShow: ({ editor: n, state: s }) => n.isActive("link") && s.selection instanceof v,
        children: /* @__PURE__ */ t("form", { onSubmit: (n) => n.preventDefault(), className: "flex items-center p-2", children: M ? /* @__PURE__ */ t(
          w,
          {
            initialValue: a ?? "",
            onSaveLink: m,
            openFileSelector: () => {
              e.commands.blur(), c(!0);
            },
            schemeOptions: i == null ? void 0 : i.schemeOptions
          }
        ) : /* @__PURE__ */ t(O, { href: a ?? "", unsetLink: L, setIsEditing: l }) })
      }
    ),
    /* @__PURE__ */ t(
      x,
      {
        uploadingFromSource: o,
        initialSearchFilters: {
          source: [o],
          name: "",
          type: []
        },
        opened: f,
        onClose: () => {
          c(!1), u();
        },
        onSelect: (n) => {
          m(n.path), c(!1);
        }
      }
    )
  ] });
};
export {
  I as LinkBubbleMenu
};
